import { connect } from 'react-redux';
import { getPurchaseHistory } from '../actions/PurchaseHistoryActions';
import PurchaseHistory from '../components/PurchaseHistory/PurchaseHistory';
import { downloadProduct } from '../actions/DownloadActions';
import { requestInvoice } from '../actions/ProfileAction';

const mapStateToProps = state => {
	return {
		purchaseHistory: state.purchaseHistory.purchaseHistory,
		loading: state.purchaseHistory.loading,
		downloading: state.downloads.downloading,
		downloadItem: state.downloads.downloadItem,
		invoiceRequested: state.profile.requestInvoice,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPurchaseHistory: () => dispatch(getPurchaseHistory()),
		download: data => dispatch(downloadProduct(data)),
		requestInvoice: () => dispatch(requestInvoice()),
	};
};

const PurchaseHistoryContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PurchaseHistory);

export default PurchaseHistoryContainer;
